export const DEFAULT_SUBDOMAIN = 'www';
